<div _ngcontent-gxn-c53="" class="main-header">
    <figure class="wp-block-image size-full is-resized">
        <a href="https://domowy.ceo.org.pl/" target="_blank">
            <img loading="lazy" src="../../../../assets/header.png" alt="" class="wp-image-26" width="1024" height="314">
        </a>
    </figure>
</div>